import { render, staticRenderFns } from "./billsToPay.vue?vue&type=template&id=3f65cad7&scoped=true&"
import script from "./billsToPay.vue?vue&type=script&lang=js&"
export * from "./billsToPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f65cad7",
  null
  
)

export default component.exports